import { render, staticRenderFns } from "./MudText.vue?vue&type=template&id=66e715e6&"
import script from "./MudText.vue?vue&type=script&lang=js&"
export * from "./MudText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports